import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        placement: 'top',
      },
      styleOverrides: {
        tooltip: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            bgcolor: theme.palette.grey['700'],
            typography: 'caption',
            px: 2,
            py: 1,
          }),
        arrow: ({ theme }) => ({
          color: theme.palette.grey['700'],
        }),
      },
    },
  },
});

export default theme.components;
